// Config.js
import axios from 'axios';

//\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
// SET axios base URL for IOSPER API
axios.defaults.baseURL = `${process.env.REACT_APP_IOSPER_ENDPOINT_BASE_URL}`;

export default axios;
